import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SeoHelmet = () => {
  const { t, i18n } = useTranslation();

  return (
    <Helmet>
      <html lang={i18n.language} />
      <title>{t('meta.title')}</title>
      <meta name="description" content={t('meta.description')} />
      <meta property="og:title" content={t('meta.title')} />
      <meta property="og:description" content={t('meta.description')} />
    </Helmet>
  );
};

export default SeoHelmet;
